<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-10 15:13:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/category/firstproduct/components/TagList/index.vue
-->
<template>
  <div class="tag_list">
    <div
      v-for="(item, index) in tagList"
      :key="index"
      :class="{ tag_choose: tagIndex === index }"
      class="tag_item"
      @click="switchTag(index, item.id)"
    >
      {{ item.name }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tagList: [
        {
          name: "全部",
          id: -1
        },
        // {
        //   name: "海外仓",
        //   id: 0
        // },
        {
          name: "保税区",
          id: 1
        },
        {
          name: "一般贸易",
          id: 2
        }
      ],
      tagIndex: 0
    };
  },
  methods: {
    // 切换标签
    switchTag(index, id) {
      this.tagIndex = index;
      this.$emit("switchTag", index, id);
    }
  }
};
</script>
<style lang="less" scoped>
// 标签
.tag_list {
  margin: 12px 12px 0;
  display: flex;
  align-items: center;
  overflow-y: hidden;
  flex-wrap: wrap;
  justify-content: flex-start;
  .tag_item {
    display: inline-block;
    border-radius: 11px;
    border: 1px solid #979797;
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.55);
    line-height: 21px;
    padding: 0 12px;
    margin: 0 8px 12px 0;
  }
  .tag_choose {
    border: 1px solid #bf9264;
    color: #bf9264;
    background: rgba(191, 146, 100, 0.2);
  }
}
</style>
